import { ROLE_PERMISSIONS, type PermissionKey } from '@/config/permissions.config'
import { useAuthStore } from '@/stores/auth.store'

export function usePermission() {
  const authStore = useAuthStore()

  const hasPermission = (permission: PermissionKey): boolean => {
    if (!authStore.user) return false
    const rolePermissions = ROLE_PERMISSIONS[authStore.user.role]
    return rolePermissions?.includes(permission) || false
  }

  const hasAllPermissions = (permissions: PermissionKey[]): boolean => {
    return permissions.every((permission) => hasPermission(permission))
  }

  const hasAnyPermission = (permissions: PermissionKey[]): boolean => {
    return permissions.some((permission) => hasPermission(permission))
  }

  const requiresPermission = (permission: PermissionKey): boolean => {
    return hasPermission(permission)
  }

  return {
    hasPermission,
    hasAllPermissions,
    hasAnyPermission,
    requiresPermission
  }
}
